var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginPageLeftImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 840.006,
    height: 498.555,
    viewBox: "0 0 840.006 498.555",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M.937,36.753S1.228,25.4.063,24.232,14.04-11.294,30.639,3.848,34.425,25.1,34.425,25.1s-6.115,11.353-5.819,12.521-27.082,0-27.082,0Z",
    transform: "translate(245.266 93.676) rotate(150)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2347",
    "data-name": "Path 2347",
    d: "M420.739,412.839h674.278a10.8,10.8,0,1,1,0,21.591h-19.1v258.25a10.8,10.8,0,1,1-21.591,0l-.164-258.25H463.089v258.25a10.8,10.8,0,0,1-21.59,0l-3.141-258.25h-17.62a10.8,10.8,0,1,1,0-21.591Z",
    transform: "translate(-338.668 -207.172)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    d: "M400.973,371.852v45.714H515.5a22.871,22.871,0,1,0,1.59-45.715q-.795-.027-1.59,0Z",
    transform: "translate(238.499 -214.286)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    "data-name": "Path 2349",
    d: "M398.873,417.369a1.759,1.759,0,0,0,1.758,1.758H518.26a24.089,24.089,0,0,0,0-48.177H400.631a1.758,1.758,0,1,0,0,3.516H518.26a20.571,20.571,0,0,1,0,41.142H400.631a1.759,1.759,0,0,0-1.758,1.76Z",
    transform: "translate(237.786 -214.44)",
    fill: "#a47cea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2350",
    "data-name": "Path 2350",
    d: "M413.909,380.944H536.986a.352.352,0,0,0,.007-.7H413.909a.352.352,0,0,0,0,.7Z",
    transform: "translate(225.563 -212.827)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    d: "M413.872,388.136H536.948a.352.352,0,1,0,.007-.7H413.872a.352.352,0,0,0,0,.7Z",
    transform: "translate(225.601 -211.58)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    d: "M413.909,395.327H536.986a.352.352,0,0,0,.007-.7H413.909a.352.352,0,0,0,0,.7Z",
    transform: "translate(225.563 -210.332)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2353",
    "data-name": "Path 2353",
    d: "M413.871,402.519H536.947a.352.352,0,1,0,.007-.7H413.871a.352.352,0,0,0,0,.7Z",
    transform: "translate(225.602 -209.084)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    d: "M382.576,330.811v45.714H497.108a22.871,22.871,0,1,0,1.59-45.715q-.795-.027-1.59,0Z",
    transform: "translate(278.486 -221.407)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    d: "M380.475,376.328a1.759,1.759,0,0,0,1.758,1.758H499.862a24.089,24.089,0,1,0,0-48.177H382.233a1.758,1.758,0,1,0,0,3.516H499.862a20.571,20.571,0,1,1,0,41.142H382.233a1.759,1.759,0,0,0-1.758,1.758Z",
    transform: "translate(277.774 -221.561)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M395.51,339.9H518.587a.352.352,0,1,0,.007-.7H395.51a.352.352,0,1,0,0,.7Z",
    transform: "translate(265.553 -219.949)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M395.51,347.094H518.587a.352.352,0,1,0,.007-.7H395.51a.352.352,0,1,0,0,.7Z",
    transform: "translate(265.553 -218.701)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2358",
    "data-name": "Path 2358",
    d: "M395.51,354.286H518.587a.352.352,0,1,0,.007-.7H395.51a.352.352,0,1,0,0,.7Z",
    transform: "translate(265.553 -217.453)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2359",
    "data-name": "Path 2359",
    d: "M395.51,361.478H518.587a.352.352,0,1,0,.007-.7H395.51a.352.352,0,1,0,0,.7Z",
    transform: "translate(265.553 -216.206)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    d: "M473.768,557.558V517.7a6.644,6.644,0,0,1,6.642-6.643H631.543a6.644,6.644,0,0,1,6.643,6.642v39.859Z",
    transform: "translate(54.06 -190.129)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_635",
    "data-name": "Rectangle 635",
    width: 164.418,
    height: 51.484,
    transform: "translate(527.828 382.378)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2361",
    "data-name": "Path 2361",
    d: "M638.185,620.029v39.858a6.644,6.644,0,0,1-6.643,6.644H480.411a6.643,6.643,0,0,1-6.643-6.643V620.029Z",
    transform: "translate(54.061 -171.22)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_427",
    "data-name": "Ellipse 427",
    cx: 4.983,
    cy: 4.983,
    rx: 4.983,
    ry: 4.983,
    transform: "translate(605.884 340.859)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_428",
    "data-name": "Ellipse 428",
    cx: 4.983,
    cy: 4.983,
    rx: 4.983,
    ry: 4.983,
    transform: "translate(605.884 407.29)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_429",
    "data-name": "Ellipse 429",
    cx: 4.983,
    cy: 4.983,
    rx: 4.983,
    ry: 4.983,
    transform: "translate(605.617 472.315)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2362",
    "data-name": "Path 2362",
    d: "M480.224,472.332v45.714H594.756a22.871,22.871,0,1,0,1.592-45.714q-.8-.027-1.592,0Z",
    transform: "translate(66.245 -196.85)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2363",
    "data-name": "Path 2363",
    d: "M478.115,517.849a1.759,1.759,0,0,0,1.758,1.758H597.5a24.089,24.089,0,1,0,.029-48.177H479.873a1.758,1.758,0,1,0,0,3.516H597.5a20.571,20.571,0,1,1,0,41.142H479.871a1.759,1.759,0,0,0-1.756,1.76Z",
    transform: "translate(65.54 -197.005)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2364",
    "data-name": "Path 2364",
    d: "M493.16,481.424H616.237a.352.352,0,1,0,.007-.7H493.16a.352.352,0,1,0,0,.7Z",
    transform: "translate(53.308 -195.392)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2365",
    "data-name": "Path 2365",
    d: "M493.16,488.616H616.237a.352.352,0,1,0,.007-.7H493.16a.352.352,0,1,0,0,.7Z",
    transform: "translate(53.308 -194.144)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2366",
    "data-name": "Path 2366",
    d: "M493.16,495.807H616.237a.352.352,0,1,0,.007-.7H493.16a.352.352,0,1,0,0,.7Z",
    transform: "translate(53.308 -192.897)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2367",
    "data-name": "Path 2367",
    d: "M493.16,503H616.237a.352.352,0,1,0,.007-.7H493.16a.352.352,0,1,0,0,.7Z",
    transform: "translate(53.308 -191.649)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2368",
    "data-name": "Path 2368",
    d: "M428.1,317.815h52.184a3.223,3.223,0,0,1,1.431.332l13.17,6.593a2.4,2.4,0,0,1,0,4.418l-13.17,6.593a3.225,3.225,0,0,1-1.431.332H428.1a2.739,2.739,0,0,1-2.89-2.541V320.356A2.739,2.739,0,0,1,428.1,317.815Z",
    transform: "translate(252.878 -223.661)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2369",
    "data-name": "Path 2369",
    d: "M474.506,320.356v13.185a2.739,2.739,0,0,0,2.89,2.542h10.4V317.815H477.4a2.739,2.739,0,0,0-2.89,2.542Z",
    transform: "translate(203.584 -223.661)",
    fill: "#a47cea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    transform: "translate(531.624 32.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2370",
    "data-name": "Path 2370",
    d: "M262.365,519.071a28.16,28.16,0,0,1-27.189-4.79c-9.524-7.993-12.511-21.164-14.94-33.359l-7.187-36.07,15.046,10.36c10.82,7.451,21.884,15.139,29.376,25.931s10.762,25.523,4.742,37.2",
    transform: "translate(-184.43 -444.852)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2371",
    "data-name": "Path 2371",
    d: "M236.964,574.426c1.526-11.092,3.089-22.324,2.021-33.539-.948-9.957-3.987-19.682-10.171-27.656a46.005,46.005,0,0,0-11.8-10.7c-1.18-.745-2.267,1.126-1.091,1.867a43.736,43.736,0,0,1,17.3,20.874c3.766,9.58,4.371,20.024,3.721,30.2-.392,6.154-1.224,12.268-2.063,18.374a1.12,1.12,0,0,0,.756,1.33,1.088,1.088,0,0,0,1.33-.756Z",
    transform: "translate(-160.31 -456.535)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2372",
    "data-name": "Path 2372",
    d: "M298.784,562.442a20.73,20.73,0,0,1-18.061,9.322c-9.143-.434-16.766-6.815-23.627-12.873l-20.3-17.919,13.432-.643c9.659-.462,19.569-.893,28.769,2.085s17.683,10.148,19.364,19.672",
    transform: "translate(-236.8 -464.182)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2373",
    "data-name": "Path 2373",
    d: "M257.77,592.266c-7.33-12.97-15.832-27.38-31.023-31.991a34.621,34.621,0,0,0-13.049-1.347c-1.385.119-1.04,2.255.343,2.136a32.162,32.162,0,0,1,20.824,5.509c5.872,4,10.444,9.552,14.31,15.445,2.37,3.609,4.493,7.372,6.617,11.128C256.472,594.348,258.456,593.481,257.77,592.266Z",
    transform: "translate(-176.816 -468.001)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    d: "M228.787,612.669a15.7,15.7,0,0,0-9.618-13.147v-7.5H206.593v7.734a15.688,15.688,0,0,0-9.095,12.911l-2.957,34.374h37.206Z",
    transform: "translate(-136.09 -474.752)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M676.643,416.382l5.509-2.32,3.78-27.619h50.332l4.1,27.507,4.929,2.464a1.171,1.171,0,0,1-.524,2.217H677.1a1.171,1.171,0,0,1-.454-2.25Z",
    transform: "translate(-290.928 -211.751)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    d: "M601.23,395.453H848.471a4.9,4.9,0,0,0,4.887-4.9V355.691H596.342v34.864a4.9,4.9,0,0,0,4.887,4.9Z",
    transform: "translate(-304.957 -217.087)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2377",
    "data-name": "Path 2377",
    d: "M596.15,392.663h257.5V243.486a5.915,5.915,0,0,0-5.905-5.9H602.055a5.915,5.915,0,0,0-5.905,5.9Z",
    transform: "translate(-305.023 -237.582)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2378",
    "data-name": "Path 2378",
    d: "M609.929,380.235H836.669a4.557,4.557,0,0,0,4.553-4.553V251.361a4.557,4.557,0,0,0-4.553-4.553H609.929a4.557,4.557,0,0,0-4.552,4.553V375.687a4.557,4.557,0,0,0,4.553,4.553Z",
    transform: "translate(-303.422 -235.981)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2379",
    "data-name": "Path 2379",
    d: "M807.047,398.426a13.632,13.632,0,0,0-20.732,2.671l-30.669-5.453-7.859,17.829,43.419,7.085a13.705,13.705,0,0,0,15.837-22.133Z",
    transform: "translate(-440.821 -210.302)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2380",
    "data-name": "Path 2380",
    d: "M909.9,430.67l-31.974-.4-4.047-.054-65.051-.819s-17.665-16.853-33.048-34.2l2.157-15.6A63.712,63.712,0,0,1,799.3,340.151C821.326,354.872,834.1,384.01,834.1,384.01l40.335,9.647,4.035.965,25.062,5.989Z",
    transform: "translate(-572.064 -219.784)",
    fill: "#a47cea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2381",
    "data-name": "Path 2381",
    d: "M824.049,498.962h59.683c0,2.558,65.241,4.633,65.241,4.633a23.831,23.831,0,0,1,3.911,3.706,23,23,0,0,1,5.375,14.824v3.706a23.172,23.172,0,0,1-23.163,23.163H824.048a23.182,23.182,0,0,1-23.163-23.163v-3.706a23.2,23.2,0,0,1,23.164-23.163Z",
    transform: "translate(-649.893 -192.227)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_636",
    "data-name": "Rectangle 636",
    width: 24.091,
    height: 139.05,
    transform: "translate(217.556 355.848)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2382",
    "data-name": "Path 2382",
    d: "M962.384,662.018c0,2.6-36.505,1.006-81.536,1.006s-81.536,1.6-81.536-1.006,36.505-23.244,81.536-23.244S962.384,659.415,962.384,662.018Z",
    transform: "translate(-652.172 -167.966)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2383",
    "data-name": "Path 2383",
    d: "M652.642,417.687h17.93l8.529-69.154H652.64Z",
    transform: "translate(-326.247 60.477)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    d: "M607.487,417.687h17.93l8.529-69.154h-26.46Z",
    transform: "translate(-228.102 60.477)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_430",
    "data-name": "Ellipse 430",
    cx: 31.173,
    cy: 31.173,
    rx: 31.173,
    ry: 31.173,
    transform: "translate(187.607 17.687)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2387",
    "data-name": "Path 2387",
    d: "M762.075,462.686s-10.46,55.309,29.338,62.352,97.251,11.994,97.251,11.994L914.456,657.4l34.659-3.095s-4.61-144.892-15.945-156.227S850.188,452.8,850.188,452.8Z",
    transform: "translate(-593.747 -200.238)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2388",
    "data-name": "Path 2388",
    d: "M732.269,441.471l17.406,17.458S875.352,479.176,880.2,508.2c7.32,43.824,15.965,139.124,15.965,139.124l-37.786-2.834L843.562,536.163,783.1,522.411l-68.784-37.486Z",
    transform: "translate(-486.215 -202.203)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2389",
    "data-name": "Path 2389",
    d: "M850.979,266.682c3.08-5.806,6.991-17.377,13.2-19.524a49.38,49.38,0,0,1,10.63-2.265l10.557,4.06-5.746-4.469q1.678-.1,3.354-.163l7.124,2.74-3.644-2.834c6.641-.068,13.5.622,18.641,4.665,4.388,3.447,8.733,16.5,9.436,22.038a42.153,42.153,0,0,1-.775,15.879l-1.8,1.717a22.149,22.149,0,0,1-1.416-4.5,21.335,21.335,0,0,0-10.213-13.855l-.1-.055c-3.025-1.7-6.7-1.622-10.166-1.5l-16.479.593c-3.965.143-8.233.394-11.324,2.88a18.646,18.646,0,0,0-4.528,6.559c-1.536,3.1-4.537,14.787-4.537,14.787s-1.7-2.207-2.512-.565a56.8,56.8,0,0,1-2.364-13.182A25.827,25.827,0,0,1,850.979,266.682Z",
    transform: "translate(-662.196 -236.43)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2390",
    "data-name": "Path 2390",
    d: "M978.515,290.889a13.632,13.632,0,0,1,12.335,16.873l25.071,18.491-7.518,17.973-35.034-26.611a13.705,13.705,0,0,1,5.152-26.728Z",
    transform: "translate(-898.762 -228.338)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2391",
    "data-name": "Path 2391",
    d: "M881.717,325.85l62.843,69.794s30.051-9.621,53.3-20.051l10.442-32.07a63.773,63.773,0,0,0,3.053-23.076c-32.221-8.574-69.7,23.328-69.7,23.328l-47.041-36.848Z",
    transform: "translate(-797.931 -225.55)",
    fill: "#a47cea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2392",
    "data-name": "Path 2392",
    d: "M906.359,491.764c11.212-3.873,22.8-7.877,35.311-9.381l.537-.065-.148-.52c-12.945-45.452-9.714-74.526-3.371-118.2A44.114,44.114,0,0,0,913.4,317.242l-.076-.034-35.715-2.27-.081,0-25.976,7.64a17.818,17.818,0,0,0-12.753,17.4c.286,14.363-.315,30.4-.947,47.376-1.418,38.088-2.883,77.472,5.438,103.025l.044.134.111.087a42.358,42.358,0,0,0,27.086,9.514C882.185,500.114,894.081,496,906.359,491.764Z",
    transform: "translate(-675.935 -224.16)",
    fill: "#a47cea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    d: "M111.551,662.91H949.129c.668,0,1.214-.743,1.214-1.661s-.544-1.661-1.214-1.661H111.551c-.668,0-1.214.743-1.214,1.661S110.88,662.91,111.551,662.91Z",
    transform: "translate(-110.337 -164.355)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M866.4,677.967a53.329,53.329,0,0,1-4.866-5.944c-2.823-3.911-5.328,16.134-5.328,16.134s-2.717,8.152-2.038,12.228,16.3,4.075,19.02,3.4,16.3,0,16.3,0H909.87c17.662-8.151,0-13.586,0-13.586-5.438-.679-23.776-17.661-23.776-17.661l-4.075-7.472c-2.717-.679-5.438,9.51-5.438,9.51Z",
    transform: "translate(-482.287 -208.574)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2394",
    "data-name": "Path 2394",
    d: "M866.4,677.967a53.329,53.329,0,0,1-4.866-5.944c-2.823-3.911-5.328,16.134-5.328,16.134s-2.717,8.152-2.038,12.228,16.3,4.075,19.02,3.4,16.3,0,16.3,0H909.87c17.662-8.151,0-13.586,0-13.586-5.438-.679-23.776-17.661-23.776-17.661l-4.075-7.472c-2.717-.679-5.438,9.51-5.438,9.51Z",
    transform: "translate(-535.03 -208.574)",
    fill: "#090814"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPageLeftImg);
export default __webpack_public_path__ + "static/media/login-page-left-img.9927d85c5bf3243e06c1e9e98bdd8e05.svg";
export { ForwardRef as ReactComponent };